module.exports = __webpack_public_path__ + "img/img06.fba9cd12.jpeg";